import { LIMPAR_SELECAO_MAPA_VEICULO_AGENDAMENTO_VIAGEM } from '../types'

export default function limparSelecaoMapaVeiculoAgendamentoViagem (andarSelecionado) {
  return {
    type: LIMPAR_SELECAO_MAPA_VEICULO_AGENDAMENTO_VIAGEM,
    payload: { andarSelecionado }
  }
}